function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { ErrorBoundary as r } from "@sentry/react";
import { createElement as o, createContext as e, useContext as n, useMemo as t, useRef as a, useEffect as c } from "react";

var l = function l() {
  window.location.reload();
},
    s = function s(_ref) {
  var r = _ref.className,
      e = _ref.tryRecovering;
  return o("div", {
    className: r
  }, o("h2", null, "Gah. The component just crashed"), o("p", null, "You can try reloading component or refresh the page."), o("button", {
    onClick: e,
    type: "button"
  }, "Reload component"), o("button", {
    onClick: l,
    type: "button"
  }, "Refresh page"));
},
    i = e({
  FallbackComponent: s
}),
    p = function p(r) {
  var e = r.children,
      n = function (r, o) {
    var e = {};

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && o.indexOf(n) < 0 && (e[n] = r[n]);
    }

    if (null != r && "function" == typeof Object.getOwnPropertySymbols) {
      var t = 0;

      for (n = Object.getOwnPropertySymbols(r); t < n.length; t++) {
        o.indexOf(n[t]) < 0 && (e[n[t]] = r[n[t]]);
      }
    }

    return e;
  }(r, ["children"]);

  return o(i.Provider, {
    value: n
  }, e);
};

var u = function u(e) {
  var l = n(i),
      p = e.FallbackComponent || l.FallbackComponent || s,
      u = t(function () {
    return function (r) {
      return function (e) {
        return o(r, {
          error: e.error,
          componentStack: e.componentStack,
          tryRecovering: e.resetError
        });
      };
    }(p);
  }, [p]),
      m = a(null),
      y = function (r) {
    var o = a();
    return c(function () {
      o.current = r;
    }, [r]), o.current;
  }(e);

  return c(function () {
    var r = m.current;

    if (r && y && r.state.error && e.recoverableProps) {
      var _iterator = _createForOfIteratorHelper(e.recoverableProps),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _o = _step.value;
          y[_o] !== e[_o] && r.resetErrorBoundary();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, [e]), o(r, {
    ref: m,
    showDialog: !1,
    fallback: u,
    onError: e.onError
  }, e.children);
},
    m = function m(r, e) {
  var n = function n(_n) {
    return o(u, Object.assign(Object.assign({}, e), _n), o(r, _n));
  },
      t = r.displayName || r.name;

  return n.displayName = t ? "WithErrorBoundary(".concat(t, ")") : "WithErrorBoundary", n;
};

export { u as ErrorBoundary, i as ErrorBoundaryContext, p as ErrorBoundaryProvider, s as FallbackComponent, m as withErrorBoundary };